var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.tab == 'map')?_c('map-tab'):_vm._e(),(_vm.tab == 'card')?_c('card-tab'):_vm._e()],1),_c('alert-handler')],1)}
var staticRenderFns = []

export { render, staticRenderFns }